import Notification from ".";

const router = [{ path: "/notification", component: Notification, exact: true }];

export default router;
